import {Injectable, OnDestroy, OnInit} from '@angular/core';
import {BehaviorSubject} from "rxjs";
import {AlertController, ModalController, NavController} from "@ionic/angular";
import {JwtToken} from "./models/JwtToken";
import {PushNotifications} from "@capacitor/push-notifications";
import {NotificationService} from "./notification.service";

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService implements OnDestroy, OnInit {
  authToken = new BehaviorSubject<string | null>(null);
  defaultPaths: { [key: string]: { defaultPath: string }} = {
    "ph": { defaultPath: '/ph' },
    "user": { defaultPath: '/secured' }
  };
  private _jwtToken: JwtToken | null = null;
  get jwtToken(): JwtToken | null {
    if (this._jwtToken != null && this._jwtToken.isValid) {
      return this._jwtToken;
    }
    const token = this.authToken.getValue();
    if (token !== null) {
      const decodedToken = new JwtToken(token);
      if (decodedToken.isValid) {
        this._jwtToken = decodedToken;
        return this._jwtToken;
      } else {
        return null;
      }
    } else {
      return null;
    }
  }
  constructor(
    private navCtrl: NavController,
    private modalCtrl: ModalController,
    private alertCtrl: AlertController
  ) {
    this.ngOnInit();
  }

  ngOnInit(): void {
    const token = localStorage.getItem('authToken');
    this.authToken.next(token);
    this.authToken.subscribe(data => this.handleAuthentication(data));
  }
  private async handleAuthentication(data: string | null) {
    this._jwtToken = new JwtToken(data);
    this.saveAuthToken(data);

    if (this.jwtToken != null && this.jwtToken.isValid) {
      if (this.jwtToken.isInRole('ph')) {
        if (!window.location.pathname.startsWith('/ph')) {
          await this.navCtrl.navigateRoot('/ph');
        }
      } else if (this.jwtToken.isInRole('user')) {
        if (!window.location.pathname.startsWith('/secured')) {
          await this.navCtrl.navigateRoot('/secured');
        }
      } else {
        await this.handleLoggedOut();
      }
    } else {
      console.log('Not Authenticated');
      // niezautoryzowany
      if (window.location.pathname.startsWith('/ph') || window.location.pathname.startsWith('/secured')) {
        await this.handleLoggedOut();
      }
    }
  }
  private async handleLoggedOut() {
    console.log('Unauthenticated');
    await this.navCtrl.navigateRoot('/');
    if (await this.modalCtrl.getTop()) {
      await this.modalCtrl.dismiss();
    }
  }
  private saveAuthToken(data: string | null) {
    if (data !== null) {
      localStorage.setItem('authToken', data);
    } else {
      localStorage.clear();
    }
  }
  public logout() {
    this.authToken.next(null);
  }
  isAuthenticated(): boolean {
    return this.jwtToken !== null && this.jwtToken.isValid;
  }
  ngOnDestroy(): void {
  }
}
